<script lang="ts">
  import { BusinessReviewEntryType } from 'src/function-utils/data-models';
  import ReviewSocialCard from './review-social-card.svelte';
  import ReviewVideoCard from './review-video-card.svelte';

  export let message: string;
  export let user: {
    name: string;
    pictureUrl?: string;
    avatarUrl?: string;
  };
  export let date: number | string | void;
  export let reviewOriginUrl: string = '';
  export let reviewType: BusinessReviewEntryType;
  export let businessKey: string;
  export let rating: number = 0;
  export let ratingMax: number = 0;
  export let recommended: boolean = null;
  export let isCelebrity: boolean = false;
  export let disableTruncate: boolean = false;
</script>

{#if reviewType === BusinessReviewEntryType.RAVELY_VIDEO || reviewType === BusinessReviewEntryType.YOUTUBE_VIDEO}
  <ReviewVideoCard type={reviewType} {user} {reviewOriginUrl} {date} />
{:else}
  <ReviewSocialCard
    {message}
    {user}
    {date}
    {reviewOriginUrl}
    {reviewType}
    {businessKey}
    {rating}
    {ratingMax}
    {recommended}
    {isCelebrity}
    {disableTruncate}
    style={$$restProps.style}
    class={$$restProps.class}
  />
{/if}
